const Base = ({ children, className = "", ...props }) => {
    return (
      <div 
        className={`bg-gray-50 rounded-[16px] p-6 w-full overflow-hidden break-words ${className}`}
        {...props}
      >
        {children}
      </div>
    );
};

export default Base;